export default "__VITE_ASSET__DhR0QK6o__"